import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  stockCategoryPrimaryList,
  stockGroupList,
  stockItemUpdate,
  stockItemSingleData,
  stockSummaryItemVoucherList,
  unitsListing,
  stockCompanyList,
  godownList,
  openModal,
  closeModal,
} from "../../../../../redux/actions/action-creator";
import FormData from "form-data";
import ItemWithGodown from "../../create/Inventory_masters/ItemWithGodown";
import MasterCreationFooter from "../../../../../components/Footer/Master_Footer/MasterCreationFooter";
import InputField from "../../../../../components/Input/InputField";
import Form from "../../../../../components/Form/Form";
import Input from "../../../../../components/Input/Input";
import ModalForm from "../../../../../components/Modal/ModalForm";
import useClickOutside from "../../../../../components/Custom_Hooks/useClickOutsSide";
import {
  prepareFormData,
  useFormHandler,
} from "../../../../../components/Custom_Hooks/useFormHandler";
import { toast } from "react-toastify";
import DropdownLayout_1 from "../../../../../components/Dropdown/DropdownLayout_1";
import {
  availlable_array,
  yes_no_array,
} from "../../../../../components/Dummi_Data";
import { useInputActionStockItem } from "../../../../../components/Custom_Hooks/useInputActionStockItem";
import StockGroupCreate from "../../create/Inventory_masters/StockGroup";
import StockCategoryCreate from "../../create/Inventory_masters/StockCatagory";
import StockCompanyCreate from "../../create/Inventory_masters/StockCompany";
import UnitCreate from "../../create/Inventory_masters/Unit";
import { parseUnitString } from "../../../../../components/Date_Formate_Utilitiy/StockItemUtility";
import { dateFormateSend } from "../../../../../components/Date_Formate_Utilitiy/Index";
import { usePermission } from "../../../../../hooks/usePermission";
import { registerAltCFocusReturn } from "../../../../../utils/altCFocusReturn";

const StockItem = React.memo(({ data_to_update, closeModal_sec, title }) => {
  const { id: paramId } = useParams();
  const id = data_to_update?.id || paramId;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [enabled, setEnabled] = useState(false);
  const [load, setLoad] = useState(false);
  const [unitEditLock, setUnitEditLock] = useState({
    locked: false,
    reason: "",
  });

  // get state data from redux ------------------------------------------------------------------------------------------
  const {
    unit_data = [],
    stock_category_under_data = [],
    stock_group_data = [],
    stock_company_data = [],
    godown_data = [],
    company_session = null,
  } = useSelector((state) => state.common);
  const notApplicable = { id: "Not Applicable", symbol: "Not Applicable" };
  const notApplicableName = { id: "Not Applicable", name: "Not Applicable" };

  // Add "Not Applicable" to each array
  const updatedStockGroupData = useMemo(
    () => [notApplicableName, ...stock_group_data],
    [stock_group_data],
  );
  const updatedStockCategoryData = useMemo(
    () => [notApplicableName, ...stock_category_under_data],
    [stock_category_under_data],
  );
  const updatedStockCompanyData = useMemo(
    () => [notApplicableName, ...stock_company_data],
    [stock_company_data],
  );
  const updatedUnitData = useMemo(() => {
    const simpleUnits = unit_data.filter((unit) => {
      const parsed = parseUnitString(unit.symbol);
      return parsed && parsed.type === "Simple";
    });
    return [notApplicable, ...simpleUnits];
  }, [unit_data]);
  const modal_state = useSelector((state) => state.common.modal_state);
  const { userData = null } = useSelector((state) => state.auth);

  const { alter, view } = usePermission("Masters", "Stock Items");

  const initialState = {
    company_id: userData?.company_id,
    name: "",
    alias_name: "",
    part_no: "",
    item_desc: "",
    notes: "",
    inactive_from: "",
    under_id: "Primary",
    under: "Primary",
    stock_cat_id: "Not Applicable",
    stock_cat: "Not Applicable",
    stock_company: "Not Applicable",
    unit_id: "Not Applicable",
    unit_name: "Not Applicable",
    unit_name_first_unit: "",
    unit_name_second_unit: "",
    unit_name_third_unit: "",
    unit_name_fourth_unit: "",
    unit_name_fifth_unit: "",
    alt_unit_id: "Not Applicable",
    alt_unit_name: "Not Applicable",
    alt_unit_name_first_unit: "",
    alt_unit_name_second_unit: "",
    alt_unit_name_third_unit: "",
    alt_unit_name_fourth_unit: "",
    alt_unit_name_fifth_unit: "",
    where_unit_name: "",
    where_alternate_unit_name: "",
    where_alternate_unit: "1",
    where_unit: "1",
    default_unit: "Not Applicable",
    default_unit_id: "Not Applicable",
    default_unit_rate: "Not Applicable",
    default_unit_rate_id: "Not Applicable",
    weight: "Not Available",
    per_unit: "",
    per_alt_unit: "",

    set_standard_rate: "No",
    costing_method: "",
    market_valuation: "",
    provide_behaviour_opt: "No",
    ignore_diff_physical: "No",
    ignore_negative_balance: "No",
    treat_sale_manufacture: "No",
    treat_purchased_consumed: "No",
    treat_rejection_scrap: "No",

    data_item: [
      {
        id: "1",
        godown_name: "",
        location: "",
        quantity: "",
        combination_of_units: "",
        rate: "",
        id_unit: "",
        per: "",
        value: "",
        total_nos_box: "",
        total_no_box_unit: "",
      },
    ],
    modal_type: "",
    total_quantitiy_allocation: "",
    total_amount_allocation: "",
    quantity: "",
    rate: "",
    per: "",
    value: "",
    total_nos_box: "",
    total_no_box_unit: "",
    opening_date: userData?.books_being_date,
    opening_balance: "",

    // gst
    GST_applicable: "Applicable",
    HSN_SAC_details: "As per Company/Stock Group",
    source_details: "Not Applicable",
    HSN_SAC: "",
    description: "",

    GST_rate_details: "As per Company/Stock Group",
    source_of_details: "Not Applicable",
    taxability_type: "",
    IGST_rate: "0",
    CGST_rate: "0",
    SGST_UTGST_rate: "0",
    cess_validation: "Not Applicable",
    cess_rate: "0",
    application_of_reverse: "No",
    eligible_tax_credit: "No",
    rate_of_Duty: "",
    type_of_supply: "Goods",
  };

  const [nameInput, setNameInput] = useState(null);
  const inputRefs = {
    name: useRef(null),
    alias_name: useRef(null),
    part_no: useRef(null),
    item_desc: useRef(null),
    notes: useRef(null),
    inactive_from: useRef(null),
    under_id: useRef(null),
    stock_cat: useRef(null),
    stock_company: useRef(null),
    unit_name: useRef(null),
    alt_unit_name: useRef(null),
    where_alternate_unit: useRef(null),
    where_unit: useRef(null),
    default_unit_id: useRef(null),
    default_unit_rate: useRef(null),
    weight: useRef(null),
    per_unit: useRef(null),
    per_alt_unit: useRef(null),

    set_standard_rate: useRef(null),
    costing_method: useRef(null),
    market_valuation: useRef(null),
    provide_behaviour_opt: useRef(null),
    ignore_diff_physical: useRef(null),
    ignore_negative_balance: useRef(null),
    treat_sale_manufacture: useRef(null),
    treat_purchased_consumed: useRef(null),
    treat_rejection_scrap: useRef(null),

    quantity: useRef(null),
    rate: useRef(null),
    per: useRef(null),
    value: useRef(null),

    // gst
    GST_applicable: useRef(null),
    HSN_SAC_details: useRef(null),
    HSN_SAC: useRef(null),
    description: useRef(null),

    GST_rate_details: useRef(null),
    source_of_details: useRef(null),
    taxability_type: useRef(null),
    IGST_rate: useRef(null),
    CGST_rate: useRef(null),
    SGST_UTGST_rate: useRef(null),
    cess_validation: useRef(null),
    cess_rate: useRef(null),
    application_of_reverse: useRef(null),
    eligible_tax_credit: useRef(null),
    rate_of_Duty: useRef(null),
    type_of_supply: useRef(null),
  };
  const dynamicInputRef = useRef({});
  const updatedAltUnitDataRef = useRef([]);
  const defaultUnitDataRef = useRef([]);
  const modalStateRef = useRef(modal_state);
  const originalUnitConfigRef = useRef(null);

  useEffect(() => {
    modalStateRef.current = modal_state;
  }, [modal_state]);

  function getCurrentInputRef(name) {
    return inputRefs[name] || null;
  }

  useEffect(() => {
    const formData = new FormData();
    formData.append("company_id", userData?.company_id);
    dispatch(unitsListing(formData));
    dispatch(godownList(formData));
    dispatch(stockGroupList(formData));
    dispatch(stockCategoryPrimaryList(formData));
    dispatch(stockCompanyList(formData));
  }, [
    modal_state?.create_under,
    modal_state?.create_stock_cat,
    modal_state?.create_stock_company,
    modal_state?.create_unit,
  ]);

  useEffect(() => {
    if (
      modal_state?.create_under ||
      modal_state?.create_stock_cat ||
      modal_state?.create_stock_company ||
      modal_state?.create_unit
    ) {
      return;
    }
  }, [
    modal_state?.create_under,
    modal_state?.create_stock_cat,
    modal_state?.create_stock_company,
    modal_state?.create_unit,
  ]);

  useEffect(() => {
    if (
      modal_state?.create_under ||
      modal_state?.create_stock_cat ||
      modal_state?.create_stock_company ||
      modal_state?.create_unit
    ) {
      return;
    }
    if (nameInput?.current) {
      nameInput?.current?.focus();
    }
  }, [
    modal_state?.create_under,
    modal_state?.create_stock_cat,
    modal_state?.create_stock_company,
    modal_state?.create_unit,
  ]);

  const cleanString = (str) => str?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();
  const hasSpecialChars = (str) => {
    return /[^a-zA-Z0-9]/.test(str); // Check if the string contains special characters
  };
  const hasNonZeroNumericToken = useCallback((value) => {
    const matches = String(value || "").match(/-?\d+(?:\.\d+)?/g) || [];
    return matches.some((match) => Number(match) !== 0);
  }, []);

  const getUnitEditLockReason = useCallback(
    (usageData) => {
      const hasOpeningStock =
        hasNonZeroNumericToken(usageData?.opening_data?.quantity) ||
        hasNonZeroNumericToken(usageData?.opening_data?.value);
      const hasTransactions =
        Array.isArray(usageData?.voucher_item_data) &&
        usageData.voucher_item_data.length > 0;

      if (hasOpeningStock) {
        return "opening stock is already recorded for this item";
      }
      if (hasTransactions) {
        return "this item is already linked with stock transactions";
      }
      return "";
    },
    [hasNonZeroNumericToken],
  );
  const validations = {
    name: (value) => value.trim() !== "",
    value: (value) => /^[0-9,.\b]*$/.test(value),
    alias_name: (value) => value.trim() !== "",
    part_no: (value) => value.trim() !== "",
    notes: (value) => value.trim() !== "",
    inactive_from: (value) => value.trim() !== "",
    under_id: (value) =>
      stock_group_data?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ) && !hasSpecialChars(value),
    stock_cat: (value) =>
      updatedStockCategoryData?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    stock_company: (value) =>
      updatedStockCompanyData?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    unit_name: (value) =>
      updatedUnitData?.some((item) =>
        cleanString(item?.symbol)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    alt_unit_name: (value) =>
      updatedAltUnitDataRef.current?.some((item) =>
        cleanString(item?.symbol)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    default_unit_id: (value) =>
      defaultUnitDataRef.current?.some((item) =>
        cleanString(item?.symbol)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    default_unit_rate: (value) =>
      defaultUnitDataRef.current?.some((item) =>
        cleanString(item?.symbol)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    weight: (value) =>
      availlable_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    set_standard_rate: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    costing_method: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    market_valuation: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    provide_behaviour_opt: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    ignore_diff_physical: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    ignore_negative_balance: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    treat_sale_manufacture: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    treat_purchased_consumed: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
    treat_rejection_scrap: (value) =>
      yes_no_array?.some((item) =>
        cleanString(item?.name)
          ?.toLowerCase()
          ?.includes(cleanString(value)?.toLowerCase()),
      ),
  };

  const refs = Object.keys(inputRefs).reduce((acc, name) => {
    acc[name] = {
      curr: getCurrentInputRef(name),
      onFocus: () => {
        const ref = getCurrentInputRef(name);
        if (ref) {
          setNameInput(ref);
          ref?.current?.setSelectionRange(0, ref?.current?.value?.length);
        }
        if (
          [
            "under_id",
            "stock_cat",
            "stock_company",
            "unit_name",
            "alt_unit_name",
            "default_unit_id",
            "default_unit_rate",
            "weight",
            "per",
          ].includes(name)
        ) {
          if (name) {
            if (
              [
                "under_id",
                "stock_cat",
                "stock_company",
                "unit_name",
                "alt_unit_name",
              ].includes(name)
            ) {
              setEnabled(true);
            }
            dispatch(openModal(name));
          }
        }
        if (
          [
            "set_default_ledger",
            "set_standard_rate",
            "provide_behaviour_opt",
            "ignore_diff_physical",
            "ignore_negative_balance",
            "treat_sale_manufacture",
            "treat_purchased_consumed",
            "treat_rejection_scrap",
          ].includes(name)
        ) {
          if (name) {
            dispatch(openModal(name));
          }
        }
      },
      onBlur: (value) => {
        if (name === "name") {
          if (!value.trim() && submitConfirmRef.current !== "Quit") {
            getCurrentInputRef(name)?.current?.focus();
          }
        }
        if (
          [
            "under_id",
            "stock_cat",
            "stock_company",
            "unit_name",
            "alt_unit_name",
            "default_unit_id",
            "default_unit_rate",
            "weight",
            "per",
          ].includes(name)
        ) {
          if (name) {
            if (
              [
                "under_id",
                "stock_cat",
                "stock_company",
                "unit_name",
                "alt_unit_name",
              ].includes(name)
            ) {
              setEnabled(false);
            }
            dispatch(closeModal(name));
          }
        }
        if (
          [
            "set_default_ledger",
            "set_standard_rate",
            "provide_behaviour_opt",
            "ignore_diff_physical",
            "ignore_negative_balance",
            "treat_sale_manufacture",
            "treat_purchased_consumed",
            "treat_rejection_scrap",
          ].includes(name)
        ) {
          if (name) {
            dispatch(closeModal(name));
          }
        }
        if (name === "treat_rejection_scrap") {
          dispatch(closeModal("provide_behaviour_opt"));
        }
      },
    };
    return acc;
  }, {});

  const {
    data,
    setData,
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    setSubmitConfirm,
    submitConfirm,
    handleItemUpdate,
    handleKeyDownItem,
    handleDynamicFocus,
    handleDynamicBlur,
    handleDropdownClick,
    handleItemDropdownClick,
    getDecimalPlaces,
  } = useInputActionStockItem({
    initialState,
    validations,
    refs,
    check_dropdown:
      modal_state?.under_id ||
      modal_state?.stock_cat ||
      modal_state?.stock_company ||
      modal_state?.unit_name ||
      modal_state?.alt_unit_name ||
      modal_state?.weight ||
      modal_state?.per,
    inputRefs,
    dynamicInputRef,
    setNameInput,
  });

  const submitConfirmRef = useRef(submitConfirm);
  useEffect(() => {
    submitConfirmRef.current = submitConfirm;
  }, [submitConfirm]);

  useEffect(() => {
    if (id) {
      setLoad(true);
      const fetchStockItemData = async () => {
        const formData = new FormData();
        formData.append("id", id);

        const usageFormData = new FormData();
        usageFormData.append("company_id", userData?.company_id);
        usageFormData.append(
          "fromDate",
          dateFormateSend(
            userData?.books_being_date || company_session?.current_date,
          ),
        );
        usageFormData.append(
          "toDate",
          dateFormateSend(company_session?.current_date),
        );
        usageFormData.append("location_id", "");
        usageFormData.append("item_id", id);
        usageFormData.append("stock_gp_id", "");
        usageFormData.append("stock_cat_id", "");
        usageFormData.append("stock_company_id", "");

        const [stockItemResult, usageResult] = await Promise.allSettled([
          dispatch(stockItemSingleData(formData)),
          userData?.company_id
            ? dispatch(stockSummaryItemVoucherList(usageFormData))
            : Promise.resolve(null),
        ]);

        if (
          stockItemResult.status === "fulfilled" &&
          stockItemResult.value?.status
        ) {
          const response = stockItemResult.value;
          const nextData = {
            company_id: userData?.company_id,
            id: id,
            name: response.data?.name || "",
            alias_name: response.data?.alias_name || "",
            part_no: response.data?.part_no || "",
            item_desc: response.data?.item_desc || "",
            notes: response.data?.notes || "",
            inactive_from: response.data?.inactive_from || "",
            under_id: response.data?.stock_group_name || "Primary",
            under: response.data?.under || "Primary",
            stock_cat_id: response.data?.stock_cat_id || "Not Applicable",
            stock_cat: response.data?.stock_category_name || "Not Applicable",
            stock_company: response.data?.stock_company || "Not Applicable",
            unit_id: response.data?.unit_id || "Not Applicable",
            unit_name: response.data?.unit_name || "Not Applicable",
            unit_name_first_unit: response.data?.unit_name_first_unit || "",
            unit_name_second_unit: response.data?.unit_name_second_unit || "",
            unit_name_third_unit: response.data?.unit_name_third_unit || "",
            unit_name_fourth_unit: response.data?.unit_name_fourth_unit || "",
            unit_name_fifth_unit: response.data?.unit_name_fifth_unit || "",
            alt_unit_id: response.data?.alt_unit_id || "Not Applicable",
            alt_unit_name: response.data?.alt_unit_name || "Not Applicable",
            alt_unit_name_first_unit:
              response.data?.alt_unit_name_first_unit || "",
            alt_unit_name_second_unit:
              response.data?.alt_unit_name_second_unit || "",
            alt_unit_name_third_unit:
              response.data?.alt_unit_name_third_unit || "",
            alt_unit_name_fourth_unit:
              response.data?.alt_unit_name_fourth_unit || "",
            alt_unit_name_fifth_unit:
              response.data?.alt_unit_name_fifth_unit || "",
            where_unit_name: response.data?.where_unit_name || "",
            where_alternate_unit_name:
              response.data?.where_alternate_unit_name || "",
            where_alternate_unit: response.data?.where_alternate_unit || "1",
            where_unit: response.data?.where_unit || "1",
            default_unit: response.data?.default_unit || "Not Applicable",
            default_unit_id: response.data?.default_unit_id || "Not Applicable",
            default_unit_rate:
              response.data?.default_unit_rate || "Not Applicable",
            default_unit_rate_id:
              response.data?.default_unit_rate_id || "Not Applicable",
            weight: response.data?.weight || "Not Available",
            per_unit: response.data?.per_unit || "",
            per_alt_unit: response.data?.per_alt_unit || "",

            set_standard_rate: response.data?.set_standard_rate || "No",
            costing_method: response.data?.costing_method || "",
            market_valuation: response.data?.market_valuation || "",
            provide_behaviour_opt: response.data?.provide_behaviour_opt || "No",
            ignore_diff_physical: response.data?.ignore_diff_physical || "No",
            ignore_negative_balance:
              response.data?.ignore_negative_balance || "No",
            treat_sale_manufacture:
              response.data?.treat_sale_manufacture || "No",
            treat_purchased_consumed:
              response.data?.treat_purchased_consumed || "No",
            treat_rejection_scrap: response.data?.treat_rejection_scrap || "No",

            data_item: response.data?.data_item || [
              {
                id: "1",
                godown_name: "",
                location: "",
                quantity: "",
                combination_of_units: "",
                rate: "",
                id_unit: "",
                per: "",
                value: "",
                total_nos_box: "",
                total_no_box_unit: "",
              },
            ],
            modal_type: "",
            total_quantitiy_allocation:
              response.data?.total_quantitiy_allocation || "",
            total_amount_allocation:
              response.data?.total_amount_allocation || "",
            quantity: response.data?.quantity || "",
            rate: response.data?.rate || "",
            per: response.data?.per || "",
            value: response.data?.value || "",
            total_nos_box: response.data?.total_nos_box || "",
            total_no_box_unit: response.data?.total_no_box_unit || "",
            opening_date:
              response.data?.opening_date || userData?.books_being_date,
            opening_balance: response.data?.opening_balance || "",

            GST_applicable: response.data?.GST_applicable || "Applicable",
            HSN_SAC_details:
              response.data?.HSN_SAC_details || "As per Company/Stock Group",
            source_details: response.data?.source_details || "Not Applicable",
            HSN_SAC: response.data?.HSN_SAC || "",
            description: response.data?.description || "",

            GST_rate_details:
              response.data?.GST_rate_details || "As per Company/Stock Group",
            source_of_details:
              response.data?.source_of_details || "Not Applicable",
            taxability_type: response.data?.taxability_type || "",
            IGST_rate: response.data?.IGST_rate || "0",
            CGST_rate: response.data?.CGST_rate || "0",
            SGST_UTGST_rate: response.data?.SGST_UTGST_rate || "0",
            cess_validation: response.data?.cess_validation || "Not Applicable",
            cess_rate: response.data?.cess_rate || "0",
            application_of_reverse:
              response.data?.application_of_reverse || "No",
            eligible_tax_credit: response.data?.eligible_tax_credit || "No",
            rate_of_Duty: response.data?.rate_of_Duty || "",
            type_of_supply: response.data?.type_of_supply || "Goods",
          };

          originalUnitConfigRef.current = {
            unit_name: nextData.unit_name,
            alt_unit_name: nextData.alt_unit_name,
            where_unit: String(nextData.where_unit ?? ""),
            where_alternate_unit: String(nextData.where_alternate_unit ?? ""),
          };
          setData(nextData);

          if (usageResult.status === "fulfilled" && usageResult.value?.status) {
            const reason = getUnitEditLockReason(usageResult.value.data);
            setUnitEditLock({ locked: !!reason, reason });
          } else {
            setUnitEditLock({ locked: false, reason: "" });
          }
        }

        if (stockItemResult.status === "rejected") {
          throw stockItemResult.reason;
        }
      };

      fetchStockItemData()
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoad(false);
        });
    }
  }, [
    id,
    dispatch,
    userData?.company_id,
    userData?.books_being_date,
    company_session?.current_date,
    getUnitEditLockReason,
  ]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.altKey && (event.key === "c" || event.key === "C")) {
        if (document.activeElement === inputRefs?.under_id?.current) {
          event.preventDefault();
          registerAltCFocusReturn("create_under");
          dispatch(openModal("create_under"));
        } else if (document.activeElement === inputRefs?.stock_cat?.current) {
          event.preventDefault();
          registerAltCFocusReturn("create_stock_cat");
          dispatch(openModal("create_stock_cat"));
        } else if (
          document.activeElement === inputRefs?.stock_company?.current
        ) {
          event.preventDefault();
          registerAltCFocusReturn("create_stock_company");
          dispatch(openModal("create_stock_company"));
        } else if (
          document.activeElement === inputRefs?.unit_name?.current ||
          document.activeElement === inputRefs?.alt_unit_name?.current
        ) {
          event.preventDefault();
          registerAltCFocusReturn("create_unit");
          dispatch(openModal("create_unit"));
        }
      }

      if (event.key === "Escape") {
        if (
          modalStateRef.current?.create_under ||
          modalStateRef.current?.create_stock_cat ||
          modalStateRef.current?.create_stock_company ||
          modalStateRef.current?.create_unit
        ) {
          return;
        }

        if (submitConfirmRef.current) {
          event.preventDefault();
          event.stopImmediatePropagation();
          handleFocusReset();
          return;
        }
        const activeModals = Object.keys(modalStateRef.current || {}).filter(
          (key) => modalStateRef.current[key],
        );
        const closableModals = [
          "under_id",
          "stock_cat",
          "stock_company",
          "unit_name",
          "alt_unit_name",
          "default_unit_id",
          "default_unit_rate",
          "weight",
          "set_default_ledger",
          "set_standard_rate",
          "provide_behaviour_opt",
          "ignore_diff_physical",
          "ignore_negative_balance",
          "treat_sale_manufacture",
          "treat_purchased_consumed",
          "treat_rejection_scrap",
          "itemwithgodown",
        ];

        const openClosableModals = activeModals.filter((modal) =>
          closableModals.includes(modal),
        );
        if (openClosableModals?.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openClosableModals.forEach((modal) => {
            if (modal === "itemwithgodown") {
              inputRefs.quantity.current?.focus();
            }
            dispatch(closeModal(modal));
          });
        } else {
          event.preventDefault();
          event.stopImmediatePropagation();
          submitConfirmRef.current = "Quit";
          setSubmitConfirm("Quit");
          document.activeElement?.blur();
        }
      }
    };
    window.addEventListener("keydown", handleKeyPress, true);
    return () => {
      window.removeEventListener("keydown", handleKeyPress, true);
    };
  }, [dispatch, inputRefs, setSubmitConfirm]);

  const default_unit_data = useMemo(() => {
    const separateCompoundUnits = (mainUnitName, alternateUnitName) => {
      const units = [];
      const extractUnitsFromString = (unitString) => {
        const unitStr = String(unitString).trim();
        if (!unitStr || unitStr === "Not Applicable") {
          return [];
        }
        const compoundPattern = /(.+)\s+of\s+([0-9.]+)\s+(.+)/i;
        const match = unitStr.match(compoundPattern);

        if (match) {
          const [, containerUnit, quantity, baseUnit] = match;
          return [
            { name: containerUnit, id: `${containerUnit}` },
            { name: baseUnit, id: `${baseUnit}` },
          ];
        } else {
          return [{ name: unitString, id: `${unitString}` }];
        }
      };

      const mainUnits = extractUnitsFromString(mainUnitName);
      units.push(...mainUnits);

      const alternateUnits = extractUnitsFromString(alternateUnitName);
      units.push(...alternateUnits);

      const uniqueUnits = units.filter(
        (unit, index, self) =>
          index === self.findIndex((u) => u.name === unit.name),
      );

      return uniqueUnits;
    };

    return separateCompoundUnits(data?.unit_name, data?.alt_unit_name);
  }, [data?.unit_name, data?.alt_unit_name]);

  useEffect(() => {
    defaultUnitDataRef.current = default_unit_data;
  }, [default_unit_data]);

  useEffect(() => {
    const unitInfo = parseUnitString(data?.unit_name);
    const altUnitInfo = parseUnitString(data?.alt_unit_name);

    const unitUpdates = {
      unit_name_first_unit: unitInfo?.mainUnit || "",
      unit_name_second_unit: unitInfo?.baseUnit || "",
    };
    const altUnitUpdates = {
      alt_unit_name_first_unit: altUnitInfo?.mainUnit || "",
      alt_unit_name_second_unit: altUnitInfo?.baseUnit || "",
    };

    const where_unit_name =
      unitInfo?.type === "Compound"
        ? unitInfo.baseUnit || ""
        : unitInfo?.mainUnit || "";
    const where_alternate_unit_name = altUnitInfo?.mainUnit || "";

    setData((prev) => {
      if (
        prev.unit_name_first_unit === unitUpdates.unit_name_first_unit &&
        prev.unit_name_second_unit === unitUpdates.unit_name_second_unit &&
        prev.alt_unit_name_first_unit ===
          altUnitUpdates.alt_unit_name_first_unit &&
        prev.alt_unit_name_second_unit ===
          altUnitUpdates.alt_unit_name_second_unit &&
        prev.where_unit_name === where_unit_name &&
        prev.where_alternate_unit_name === where_alternate_unit_name &&
        prev.where_unit === (where_unit_name ? "1" : "0") &&
        prev.where_alternate_unit === (where_alternate_unit_name ? "1" : "0")
      ) {
        return prev;
      }
      return {
        ...prev,
        ...unitUpdates,
        ...altUnitUpdates,
        where_unit_name,
        where_alternate_unit_name,
        where_unit: where_unit_name
          ? prev.where_unit === "0"
            ? "1"
            : prev.where_unit
          : "0",
        where_alternate_unit: where_alternate_unit_name
          ? prev.where_alternate_unit === "0"
            ? "1"
            : prev.where_alternate_unit
          : "0",
      };
    });
  }, [data?.unit_name, data?.alt_unit_name]);

  const validateForm = () => {
    const originalUnitConfig = originalUnitConfigRef.current;
    const unitConfigurationChanged =
      unitEditLock.locked &&
      originalUnitConfig &&
      ["unit_name", "alt_unit_name", "where_unit", "where_alternate_unit"].some(
        (field) =>
          String(data?.[field] ?? "") !==
          String(originalUnitConfig?.[field] ?? ""),
      );

    if (unitConfigurationChanged) {
      toast.error(
        `Unit configuration cannot be changed because ${unitEditLock.reason}.`,
        {
          position: toast.POSITION.TOP_CENTER,
        },
      );
      setSubmitConfirm("");
      setData((prevState) => ({
        ...prevState,
        ...originalUnitConfig,
      }));
      getCurrentInputRef("unit_name")?.current?.focus();
      return false;
    }

    let requiredFields = [
      { field: "name", message: "Required Name Field" },
      { field: "under_id", message: "Required Name Field" },
      { field: "stock_cat", message: "Required Name Field" },
      { field: "stock_company", message: "Required Name Field" },
      { field: "unit_name", message: "Required Name Field" },
      { field: "name", message: "Required Name Field" },
    ];
    const check_under = stock_group_data?.some(
      (item) => item?.name === data?.under_id,
    );
    const check_stock_cat = updatedStockCategoryData?.some(
      (item) => item?.name === data?.stock_cat,
    );
    const check_stock_company = updatedStockCompanyData?.some(
      (item) => item?.name === data?.stock_company,
    );
    const check_unit_name = updatedUnitData?.some(
      (item) => item?.symbol === data?.unit_name,
    );
    const check_alt_unit_name = updatedAltUnitData?.some(
      (item) => item?.symbol === data?.alt_unit_name,
    );

    if (
      !check_under ||
      !check_stock_cat ||
      !check_stock_company ||
      !check_unit_name
    ) {
      toast.error("Value not match From Dropdown", {
        position: toast.POSITION.TOP_CENTER,
      });
      setSubmitConfirm("");
      getCurrentInputRef(
        !check_under
          ? "under_id"
          : !check_stock_cat
            ? "stock_cat"
            : !check_stock_company
              ? "stock_company"
              : "unit_name",
      )?.current?.focus();
      return false;
    }
    if (check_unit_name) {
      if (data?.unit_name === "Not Applicable") {
        setData((prevState) => ({
          ...prevState,
          alt_unit_name: data?.unit_name,
          alt_unit_id: data?.unit_id,
          where_unit: 0,
          where_alternate_unit: 0,
          quantity: "",
          rate: "",
          per: "",
        }));
      } else if (!check_alt_unit_name) {
        toast.error("Value not match From Dropdown", {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        getCurrentInputRef("alt_unit_name")?.current?.focus();
        return false;
      } else if (
        check_alt_unit_name &&
        data?.alt_unit_name !== "Not Applicable"
      ) {
        if (data?.where_unit <= 0) {
          toast.error("Value should be greater than 0", {
            position: toast.POSITION.TOP_CENTER,
          });
          setSubmitConfirm("");
          getCurrentInputRef("where_unit")?.current?.focus();
          return false;
        } else if (data?.where_alternate_unit <= 0) {
          toast.error("Value should be greater than 0", {
            position: toast.POSITION.TOP_CENTER,
          });
          setSubmitConfirm("");
          getCurrentInputRef("where_alternate_unit")?.current?.focus();
          return false;
        }
      }
    }

    for (let { field, message } of requiredFields) {
      if (!data?.[field]) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm("");
        getCurrentInputRef(field)?.current?.focus();
        return false;
      }
    }
    return true;
  };

  const resetForm = () => {
    setData(initialState);
  };

  const { handleSubmit, loading, handleFocusReset } = useFormHandler({
    validateForm,
    prepareFormData: () => prepareFormData(data),
    submitForm: (data) => dispatch(stockItemUpdate(data)),
    shortcuts: [
      {
        key: "a",
        ctrlKey: true,
        action: () => handleSubmit(new Event("submit")),
      },
    ],
    resetForm,
    first_ref: inputRefs?.name,
    closeModal: () => navigate("/chart-of-account-invmas-stockitem"),
    setSubmitConfirm,
    submitConfirm,
  });

  const updatedAltUnitData = useMemo(() => {
    const filter_alt_unit = unit_data.filter((unit) => {
      const firstUnitValue = data?.unit_name?.trim();
      if (!firstUnitValue) return true;

      const firstUnitWords = firstUnitValue
        .split(" ")
        .filter((word) => isNaN(Number(word)) && word.toLowerCase() !== "of");
      const unitWords = unit.symbol
        .split(" ")
        .filter((word) => isNaN(Number(word)) && word.toLowerCase() !== "of");
      const match = firstUnitWords.some((word) =>
        unitWords.some((unitWord) =>
          unitWord.toLowerCase().includes(word.toLowerCase()),
        ),
      );
      if (
        firstUnitWords.every((word) =>
          unit.symbol.toLowerCase().includes(word.toLowerCase()),
        )
      ) {
        return false;
      }
      if (match) {
        return false;
      }
      return true;
    });
    return [notApplicable, ...filter_alt_unit];
  }, [unit_data, data?.unit_name]);

  useEffect(() => {
    updatedAltUnitDataRef.current = updatedAltUnitData;
  }, [updatedAltUnitData]);

  const handleClickOutside = (event) => {
    if (
      modal_state?.create_under ||
      modal_state?.create_stock_cat ||
      modal_state?.create_stock_company ||
      modal_state?.create_unit
    )
      return;
    if (nameInput?.current) {
      event.preventDefault();
      nameInput?.current?.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (
      clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === "input" ||
        clickedElement?.tagName.toLowerCase() === "textarea")
    ) {
      clickedElement.focus();
    }
  };
  useClickOutside(nameInput, handleClickOutside, handleClickInside);

  const main_unit_per = useMemo(() => {
    const unitInfo = parseUnitString(data?.unit_name);
    const options = [];
    let idCounter = 1;

    if (unitInfo) {
      if (unitInfo.type === "Compound") {
        options.push({ id: idCounter++, name: unitInfo.mainUnit });
        options.push({ id: idCounter++, name: unitInfo.baseUnit });
      } else {
        options.push({ id: idCounter++, name: unitInfo.mainUnit });
      }
    }

    if (data?.alt_unit_name && data?.alt_unit_name !== "Not Applicable") {
      const altUnitInfo = parseUnitString(data.alt_unit_name);
      if (altUnitInfo && altUnitInfo.type === "Compound") {
        options.push({ id: idCounter++, name: altUnitInfo.mainUnit });
        options.push({ id: idCounter++, name: altUnitInfo.baseUnit });
      } else {
        options.push({ id: idCounter++, name: data.alt_unit_name });
      }
    }
    return options;
  }, [data?.unit_name, data?.alt_unit_name]);

  const inputFields = [
    { label: "Name", name: "name", type: "text", isRequired: true },
    { label: "(alias)", name: "alias_name", type: "text", isRequired: false },
    { label: "Part No.", name: "part_no", type: "text", isRequired: false },
    {
      label: "Description",
      name: "item_desc",
      type: "text",
      isRequired: false,
    },
    { label: "Notes", name: "notes", type: "text", isRequired: false },
    {
      label: "Inactive From Date",
      name: "inactive_from",
      type: "text",
      isRequired: false,
      placeholder: "DD-MM-YYYY",
    },
    { label: "Under", name: "under_id", type: "text", isRequired: false },
    { label: "Category", name: "stock_cat", type: "text", isRequired: false },
    {
      label: "Company",
      name: "stock_company",
      type: "text",
      isRequired: false,
    },
    {
      label: "Unit",
      name: "unit_name",
      type: "text",
      isRequired: false,
      isDisabled: unitEditLock.locked,
    },
    {
      label: "Alternate units",
      name: "alt_unit_name",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable" || unitEditLock.locked,
    },
    {
      label: "",
      name: "where_alternate_unit",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable" || unitEditLock.locked,
    },
    {
      label: "",
      name: "where_unit",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable" || unitEditLock.locked,
    },
    {
      label: "Default Unit For Quantity",
      name: "default_unit_id",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Default Unit For Rate ",
      name: "default_unit_rate",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Weight",
      name: "weight",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Per Unit",
      name: "per_unit",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Per Alternate Unit",
      name: "per_alt_unit",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Set standard rates",
      name: "set_standard_rate",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.set_standard_rate,
      isDisabled: true,
    },
    {
      label: "Costing Method",
      name: "costing_method",
      type: "text",
      isRequired: false,
      isDisabled: true,
    },
    {
      label: "Market Valuation Method",
      name: "market_valuation",
      type: "text",
      isRequired: false,
      isDisabled: true,
    },
    {
      label: "Provide Behaviour options",
      name: "provide_behaviour_opt",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.provide_behaviour_opt,
      isDisabled: true,
    },
    {
      label: "Ignore difference due to physical counting",
      name: "ignore_diff_physical",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.ignore_diff_physical,
      isDisabled: true,
    },
    {
      label: "Ignore negative balances",
      name: "ignore_negative_balance",
      type: "text",
      isRequired: true,
      isDrop: false,
      state: modal_state?.ignore_negative_balance,
      isDisabled: true,
    },
    {
      label: "Treat all sales as new manufacture",
      name: "treat_sale_manufacture",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.treat_sale_manufacture,
      isDisabled: true,
    },
    {
      label: "Treat all purchases as consumed",
      name: "treat_purchased_consumed",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.treat_purchased_consumed,
      isDisabled: true,
    },
    {
      label: "Treat all rejections inward as scrap",
      name: "treat_rejection_scrap",
      type: "text",
      isRequired: false,
      isDrop: true,
      state: modal_state?.treat_rejection_scrap,
      isDisabled: true,
    },
    {
      label: "Quantity",
      name: "quantity",
      type: "text",
      isRequired: false,
      isDisabled: data?.unit_name === "Not Applicable",
    },
    {
      label: "Rate",
      name: "rate",
      type: "text",
      isRequired: false,
      isDisabled:
        data?.unit_name === "Not Applicable" || godown_data.length > 1,
    },
    {
      label: "Per",
      name: "per",
      type: "text",
      isRequired: false,
      isDisabled:
        data?.unit_name === "Not Applicable" || godown_data.length > 1,
    },
    {
      label: "Value",
      name: "value",
      type: "text",
      isRequired: false,
      isDisabled:
        data?.unit_name === "Not Applicable" || godown_data.length > 1,
    },
  ];

  const dropdownConfig = {
    under_id: {
      title: "List of Stock Group",
      input_id: "under",
      data: stock_group_data,
    },
    stock_cat: {
      title: "List of Stock Category",
      input_id: "stock_cat_id",
      data: updatedStockCategoryData,
    },
    stock_company: {
      title: "List of Stock Company",
      data: updatedStockCompanyData,
    },
    unit_name: {
      title: "List of Unit",
      input_id: "unit_id",
      data: updatedUnitData,
    },
    alt_unit_name: {
      title: "List of Unit",
      input_id: "alt_unit_id",
      data: updatedAltUnitData,
    },
    default_unit_id: {
      title: "List of Unit",
      input_id: "default_unit",
      data: default_unit_data,
    },
    default_unit_rate: {
      title: "List of Unit",
      input_id: "default_unit_rate",
      data: default_unit_data,
    },
    weight: { title: "List of Applicable", data: availlable_array },
    per: { title: "Rate Unit", input_id: "per_id", data: main_unit_per },
  };

  if (!view || !alter) {
    if (submitConfirm === "Quit") {
      setTimeout(() => {
        if (closeModal_sec) {
          closeModal_sec();
        } else {
          window.history.back();
        }
      }, 0);
    }
    return (
      <div
        className="d-flex justify-content-center align-items-center h-100"
        style={{ minHeight: "80vh" }}
      >
        <h3>You do not have permission to access this page.</h3>
      </div>
    );
  }

  return (
    <div className="detail border position-relative">
      {modal_state?.create_under ? (
        <div
          style={{
            position: "fixed",
            top: "40px",
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 10000,
            background: "rgba(255,255,255,0.01)",
          }}
        >
          <StockGroupCreate
            title="Stock Group Creation (Secondary)"
            closeModal_sec={() => dispatch(closeModal("create_under"))}
          />
        </div>
      ) : null}
      {modal_state?.create_stock_cat ? (
        <div
          style={{
            position: "fixed",
            top: "40px",
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 10000,
            background: "rgba(255,255,255,0.01)",
          }}
        >
          <StockCategoryCreate
            title="Stock Category Creation (Secondary)"
            closeModal_sec={() => dispatch(closeModal("create_stock_cat"))}
          />
        </div>
      ) : null}
      {modal_state?.create_stock_company ? (
        <div
          style={{
            position: "fixed",
            top: "40px",
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 10000,
            background: "rgba(255,255,255,0.01)",
          }}
        >
          <StockCompanyCreate
            title="Stock Company Creation (Secondary)"
            closeModal_sec={() => dispatch(closeModal("create_stock_company"))}
          />
        </div>
      ) : null}
      {modal_state?.create_unit ? (
        <div
          style={{
            position: "fixed",
            top: "40px",
            left: 0,
            width: "100vw",
            height: "100vh",
            zIndex: 10000,
            background: "rgba(255,255,255,0.01)",
          }}
        >
          <UnitCreate
            title="Unit Creation (Secondary)"
            closeModal_sec={() => dispatch(closeModal("create_unit"))}
          />
        </div>
      ) : null}

      <Form
        handleSubmit={handleSubmit}
        handleKeyDown={handleKeyDown}
        submitConfirm={submitConfirm}
        handleFocusReset={handleFocusReset}
        title={title || "Stock Item Alteration"}
        loading={loading || load}
        col="col-12"
        Footer={MasterCreationFooter}
        closeModal_sec={closeModal_sec}
        createMasterEnabled={enabled}
      >
        {modal_state?.itemwithgodown ? (
          <ItemWithGodown
            data={data}
            data_item={data?.data_item}
            setData={setData}
            handleChange={handleItemUpdate}
            inputRefs={dynamicInputRef}
            handleKeyDownItem={handleKeyDownItem}
            handleDynamicFocus={handleDynamicFocus}
            handleDynamicBlur={handleDynamicBlur}
            handleItemDropdownClick={handleItemDropdownClick}
            getDecimalPlaces={getDecimalPlaces}
          />
        ) : null}
        {modal_state?.behavior ? (
          <div style={{ zIndex: 10000 }}>
            <ModalForm
              data={data}
              setData={setData}
              inputFields={inputFields?.slice(22, 27)}
              inputRefs={inputRefs}
              handleChange={handleChange}
              handleBlur={handleBlur}
              handleFocus={handleFocus}
              handleDropdownClick={handleDropdownClick}
            />
          </div>
        ) : null}
        <div className="row p-0 m-0 mb-1" style={{ height: "86vh" }}>
          <div className="col-5 pb-2">
            {inputFields
              .slice(0, 3)
              .map(({ label, name, type, isRequired, placeholder }, index) => (
                <InputField
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={data[name] || ""}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  isRequired={isRequired}
                  ref={inputRefs[name]}
                  placeholder={placeholder}
                  handleDropdownClick={handleDropdownClick}
                />
              ))}
          </div>
          <div className="col-7 pb-2">
            {inputFields
              .slice(3, 5)
              .map(({ label, name, type, isRequired, placeholder }, index) => (
                <InputField
                  key={index}
                  lable={label}
                  type={type}
                  name={name}
                  value={data[name] || ""}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  handleFocus={handleFocus}
                  isRequired={isRequired}
                  ref={inputRefs[name]}
                  placeholder={placeholder}
                  handleDropdownClick={handleDropdownClick}
                />
              ))}
            {inputFields
              .slice(5, 6)
              .map(
                (
                  { label, name, type, isRequired, isDrop, state, placeholder },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    ref={inputRefs[name]}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
          </div>
          <div className="border" style={{ height: "2px" }}></div>
          <div className="col-6 pt-1 border-end">
            {inputFields
              .slice(6, 11)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, placeholder },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    isDisabled={isDisabled}
                    ref={inputRefs[name]}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
            {unitEditLock.locked && (
              <div className="row m-0 p-0 mb-1">
                <div
                  className="col-11 p-0 text-start"
                  style={{ fontSize: 12, color: "#9c2f2f" }}
                >
                  Unit and alternate unit are locked because{" "}
                  {unitEditLock.reason}.
                </div>
              </div>
            )}
            {Object.entries(dropdownConfig).map(
              ([key, config]) =>
                modal_state?.[key] && (
                  <DropdownLayout_1
                    key={key}
                    title={config.title}
                    state={modal_state[key]}
                    data={data}
                    setData={setData}
                    input_value={data[key]}
                    input_key={key}
                    input_id={config?.input_id}
                    rawData={config.data}
                    ref={inputRefs[key]}
                    inputRefs={inputRefs}
                    setSubmitConfirm={setSubmitConfirm}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
            )}

            {data?.alt_unit_name !== "Not Applicable" &&
              data?.unit_name !== "Not Applicable" && (
                <div
                  className="row m-0 p-0 align-items-center"
                  style={{ height: "3.5vh" }}
                >
                  <div
                    className={`${data?.alt_unit_name === "Not Applicable" ? "text-muted " : ""}col-5 text-start m-0 p-0`}
                    style={{ fontSize: 13 }}
                  >
                    Where{" "}
                  </div>
                  <div
                    className={`${data?.alt_unit_name === "Not Applicable" ? "text-muted " : ""}text-start m-0 p-0`}
                    style={{ fontSize: 13, width: "2%" }}
                  >
                    :{" "}
                  </div>
                  <div
                    className="col-6 m-0 p-0 text-start"
                    style={{ position: "relative" }}
                  >
                    <div className="d-flex align-items-center gap-1 w-100">
                      <div style={{ flex: "1 1 30%", minWidth: "40px" }}>
                        {inputFields
                          .slice(11, 12)
                          .map(
                            (
                              { label, name, type, isRequired, isDisabled },
                              index,
                            ) => (
                              <Input
                                key={index}
                                lable={label}
                                type={type}
                                name={name}
                                value={data[name] || ""}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                handleFocus={handleFocus}
                                isRequired={isRequired}
                                isDisabled={isDisabled}
                                ref={inputRefs[name]}
                              />
                            ),
                          )}
                      </div>
                      <div
                        className="text-start text-nowrap"
                        style={{
                          fontSize: 13,
                          flex: "0 0 auto",
                          lineHeight: "26px",
                        }}
                      >
                        {data?.alt_unit_name !== "Not Applicable"
                          ? data?.alt_unit_name_fourth_unit
                            ? data?.alt_unit_name_fourth_unit
                            : data?.alt_unit_name_third_unit
                              ? data?.alt_unit_name_third_unit
                              : data?.alt_unit_name_second_unit
                                ? data?.alt_unit_name_second_unit
                                : data?.alt_unit_name_first_unit
                                  ? data?.alt_unit_name_first_unit
                                  : data?.alt_unit_name
                                    ? data?.alt_unit_name
                                    : ""
                          : ""}
                      </div>
                      <div
                        className="px-1"
                        style={{
                          fontSize: 13,
                          flex: "0 0 auto",
                          lineHeight: "26px",
                        }}
                      >
                        =
                      </div>
                      <div style={{ flex: "1 1 30%", minWidth: "40px" }}>
                        {inputFields
                          .slice(12, 13)
                          .map(
                            (
                              { label, name, type, isRequired, isDisabled },
                              index,
                            ) => (
                              <Input
                                key={index}
                                lable={label}
                                type={type}
                                name={name}
                                value={data[name] || ""}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                handleFocus={handleFocus}
                                isRequired={isRequired}
                                isDisabled={isDisabled}
                                ref={inputRefs[name]}
                              />
                            ),
                          )}
                      </div>
                      <div
                        className="text-start text-nowrap"
                        style={{
                          fontSize: 13,
                          flex: "0 0 auto",
                          lineHeight: "26px",
                        }}
                      >
                        {data?.alt_unit_name !== "Not Applicable"
                          ? data?.unit_name_fourth_unit
                            ? data?.unit_name_fourth_unit
                            : data?.unit_name_third_unit
                              ? data?.unit_name_third_unit
                              : data?.unit_name_second_unit
                                ? data?.unit_name_second_unit
                                : data?.unit_name_first_unit
                                  ? data?.unit_name_first_unit
                                  : data?.unit_name
                                    ? data?.unit_name
                                    : ""
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            {inputFields
              .slice(13, 16)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, placeholder },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    isDisabled={isDisabled}
                    ref={inputRefs[name]}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
            {data?.weight === "Available" &&
              data?.unit_name !== "Not Applicable" &&
              inputFields
                .slice(16, 17)
                .map(
                  ({ label, name, type, isRequired, placeholder }, index) => (
                    <InputField
                      key={index}
                      lable={label}
                      type={type}
                      name={name}
                      value={data[name] || ""}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleFocus={handleFocus}
                      isRequired={isRequired}
                      ref={inputRefs[name]}
                      placeholder={placeholder}
                      handleDropdownClick={handleDropdownClick}
                    />
                  ),
                )}
            {data?.weight === "Available" &&
              data?.alt_unit_name !== "Not Applicable" &&
              inputFields
                .slice(17, 18)
                .map(
                  ({ label, name, type, isRequired, placeholder }, index) => (
                    <InputField
                      key={index}
                      lable={label}
                      type={type}
                      name={name}
                      value={data[name] || ""}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      handleFocus={handleFocus}
                      isRequired={isRequired}
                      ref={inputRefs[name]}
                      placeholder={placeholder}
                      handleDropdownClick={handleDropdownClick}
                    />
                  ),
                )}
            <p
              className="text-start font-weight-bold m-0 p-0 mt-1 mb-1"
              style={{ fontWeight: "bold" }}
            >
              <u>Additional</u>
            </p>
            {inputFields
              .slice(18, 19)
              .map(
                (
                  {
                    label,
                    name,
                    type,
                    isRequired,
                    isDrop,
                    state,
                    isDisabled,
                    placeholder,
                  },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    isDisabled={isDisabled}
                    ref={inputRefs[name]}
                    show_drop={state}
                    setData={setData}
                    data={data}
                    isDrop={isDrop}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
            {inputFields
              .slice(19, 21)
              .map(
                (
                  { label, name, type, isRequired, isDisabled, placeholder },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    isDisabled={isDisabled}
                    ref={inputRefs[name]}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
            {inputFields
              .slice(21, 22)
              .map(
                (
                  {
                    label,
                    name,
                    type,
                    isRequired,
                    isDrop,
                    state,
                    isDisabled,
                    placeholder,
                  },
                  index,
                ) => (
                  <InputField
                    key={index}
                    lable={label}
                    type={type}
                    name={name}
                    value={data[name] || ""}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    handleFocus={handleFocus}
                    isRequired={isRequired}
                    isDisabled={isDisabled}
                    ref={inputRefs[name]}
                    show_drop={state}
                    setData={setData}
                    data={data}
                    isDrop={isDrop}
                    placeholder={placeholder}
                    handleDropdownClick={handleDropdownClick}
                  />
                ),
              )}
          </div>
          <div className="col-6">
            <p
              className="text-start font-weight-bold"
              style={{ fontWeight: "bold" }}
            >
              <u>Statutory Details</u>
            </p>
          </div>
          <div className="border mt-1" style={{ height: "2px" }}></div>
          <div className="col-12">
            <div className="row">
              <div className="col-3 align-content-center">
                Opening Balance :
              </div>
              <div className="col-9 pt-3">
                <div className="row">
                  {inputFields
                    .slice(27)
                    .map(
                      (
                        {
                          label,
                          name,
                          type,
                          isRequired,
                          isDisabled,
                          placeholder,
                        },
                        index,
                      ) => (
                        <div className="col-3" key={index}>
                          <InputField
                            lable={label}
                            type={type}
                            name={name}
                            value={data[name] || ""}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            handleFocus={handleFocus}
                            isRequired={isRequired}
                            isDisabled={isDisabled}
                            ref={inputRefs[name]}
                            data={data}
                            placeholder={placeholder}
                            handleDropdownClick={handleDropdownClick}
                            isVertical={true}
                          />
                        </div>
                      ),
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
});

export default StockItem;
